import { render, staticRenderFns } from "./ConfigTabPalavrasBloqueadas.vue?vue&type=template&id=0a6f4403&scoped=true"
import script from "./ConfigTabPalavrasBloqueadas.vue?vue&type=script&lang=js"
export * from "./ConfigTabPalavrasBloqueadas.vue?vue&type=script&lang=js"
import style0 from "./ConfigTabPalavrasBloqueadas.vue?vue&type=style&index=0&id=0a6f4403&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a6f4403",
  null
  
)

export default component.exports